import { render, staticRenderFns } from "./PayNew.vue?vue&type=template&id=3440a12e&scoped=true&"
import script from "./PayNew.vue?vue&type=script&lang=js&"
export * from "./PayNew.vue?vue&type=script&lang=js&"
import style0 from "./PayNew.vue?vue&type=style&index=0&id=3440a12e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3440a12e",
  null
  
)

export default component.exports